// extracted by mini-css-extract-plugin
export default {"tocLink":"ArticleTOC_tocLink__KZAwZ"};